import type { ScenarioId } from './types';

interface ScenarioMarkers {
  readonly firstNavigationElapsedMs: number;
}

const markersByScenario = new Map<ScenarioId, ScenarioMarkers>();

export const markScenarioFirstNavigation = (scenarioId: ScenarioId, elapsedSinceStartMs: number): void => {
  if (!markersByScenario.has(scenarioId)) {
    markersByScenario.set(scenarioId, { firstNavigationElapsedMs: elapsedSinceStartMs });
  }
};

export const readScenarioMarkers = (scenarioId: ScenarioId): ScenarioMarkers | undefined =>
  markersByScenario.get(scenarioId);

export const clearScenarioMarkers = (scenarioId: ScenarioId): void => {
  markersByScenario.delete(scenarioId);
};
